import { Component } from 'react';
import SearchForm from './SearchForm';
import Reward from './Reward';
import { Pagination } from 'react-bootstrap';
import '../../assets/styles/ActivReward.scss';
import BookdocApi from '../../services/BookdocApi';
import { Helmet } from 'react-helmet-async';

class ActivReward extends Component {
    constructor(props) {
        super(props);

        this.state = {
            metadata: {
                total_pages: 0,
                current_page: 1,
                total_count: 0
            },
            page: 1,
            per: 9,
            rewards: []
        };

        document.title = 'Activ Reward - BookDoc';
    }

    componentDidMount() {
        this.listRewards(1);
    }

    handleSearch = (e) => {
        e.preventDefault();
        this.listRewards(1);
    }

    handlePage = (e) => {
        e.preventDefault();
        this.listRewards(e.target.getAttribute('page'));
    }

    listRewards = (page = this.state.page, per = this.state.per) => {
        let query = {
            page: page,
            per: per
        }
        if (document.getElementById('category_id').selectedIndex > 0) {
            query.category_id = document.getElementById('category_id').options[document.getElementById('category_id').selectedIndex].value;
        }
        if (document.getElementById('award_id').selectedIndex > 0) {
            query.award_id = document.getElementById('award_id').options[document.getElementById('award_id').selectedIndex].value;
        }
        if (document.getElementById('search').value.length > 0) {
            query.search = document.getElementById('search').value;
        }
        BookdocApi.getActivRewards(query).then((data) => {
            this.setState({
                metadata: data.metadata,
                page: data.metadata.page,
                rewards: data.activ_rewards
            })
        });
    }

    render() {
        return (
            <>
                <Helmet>
                    <meta name="description" content="Go Activ Get Rewards"/>
                    <meta property="og:title" content="Activ Rewards - BookDoc" />
                    <meta property="og:description" content="Go Activ Get Rewards" />
                </Helmet>
                <SearchForm handleSearch={this.handleSearch}></SearchForm>
                <Rewards rewards={this.state.rewards}></Rewards>
                <Pages metadata={this.state.metadata} per={this.state.per} handlePage={this.handlePage} />
            </>
        );
    }
}

class Rewards extends Component {
    render() {
        const rewards = this.props.rewards.map((reward) => {
            return (
                <div className="col-md-4" key={reward.id}>
                    <div className="activ-reward">
                        <Reward reward={reward} />
                    </div>
                </div>
            );
        });

        return (
            <div className="mt-4 row">
                {rewards}
            </div>
        );
    }
}

class Pages extends Component {
    render() {
        const metadata = this.props.metadata;
        if (metadata.total_count <= 0) {
            return <div className="text-warning">No data found</div>;
        }

        let items = [];
        for (let i = Math.max(1, metadata.current_page - 2), j = Math.min(metadata.current_page + 2, Math.ceil(metadata.total_count / this.props.per)); i <= j; i++) {
            items.push(
                <Pagination.Item key={i} activeLabel="" active={metadata.current_page===i} page={i} onClick={this.props.handlePage}>{i}</Pagination.Item>
            );
        }
        return (
            <Pagination bsPrefix="pagination mt-3">
                {items}
            </Pagination>
        );
    }
}

export default ActivReward;
